import CPageTitle from 'components/pageTitle/Index'
import CNavigation from 'components/navigation/Index'
import CSidebar from 'components/sidebar/Index'

export default {
  CPageTitle,
  CNavigation,
  CSidebar,
}
